import DPagination from './src';

DPagination.install = Vue => {
  Vue.component('DPagination', DPagination);
};

export default DPagination;
